module.exports = __webpack_public_path__ + "img/sushi-king-menu-01.dac78278.png";